import {
    IButtonProperties,
} from '@vfde-brix-ws10/button';

import { renderContainerForWebchatContent } from './renderContainerForWebchatContent';

import mountButton from '../../../components/button';

import { WRAPPER_BUTTON_NAME } from '../constants';

import { IButtonLink } from '../types';

import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix-ws10/core';

/**
 * export function which renders chat bubbles
 * @param wrapper
 * @param items
 */
export const renderButton = (links: IButtonLink[], wrapperContainerId?: string) => {

    for (let i = 0; i < links.length; i++) {

        const buttonPoperties: IButtonProperties = {
            optWidthVariation: 'fullwidth',
            optColor: 'primary',
            optSize: 'standard',
            stdContent: links[i].text,
            linkHref: links[i].src,
            business: NO_PATTERN_BUSINESS_LOGIC,
            optTarget: '_blank',
        };

        // create unique container for each button
        const containerChatContentIdForChatBubbles = renderContainerForWebchatContent(WRAPPER_BUTTON_NAME + i, wrapperContainerId);

        mountButton(
            document.getElementById(containerChatContentIdForChatBubbles),
            buttonPoperties,
        );
    }
};
